// Formatare uniformă a datelor (ro-RO). Acceptă "dd.mm.yyyy" (cum vine din API pe
// signed_date/csd_date/contract_date), "yyyy-mm-dd" (date calendaristice — fără
// conversie de fus orar) și ISO datetime. Nu returnează niciodată "Invalid Date".
const DMY = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
const YMD = /^(\d{4})-(\d{2})-(\d{2})(T.*)?$/;
const pad = (n) => String(n).padStart(2, "0");

export const parseDateParts = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (v instanceof Date) {
    return isNaN(v) ? null : { d: v.getDate(), m: v.getMonth() + 1, y: v.getFullYear(), dt: v };
  }
  const s = String(v).trim();
  let m = DMY.exec(s);
  if (m) return { d: +m[1], m: +m[2], y: +m[3], dt: null };
  m = YMD.exec(s);
  if (m && !m[4]) return { d: +m[3], m: +m[2], y: +m[1], dt: null };
  const dt = new Date(s);
  if (isNaN(dt)) return null;
  return { d: dt.getDate(), m: dt.getMonth() + 1, y: dt.getFullYear(), dt };
};

export const formatRoDate = (v) => {
  const p = parseDateParts(v);
  return p ? `${pad(p.d)}.${pad(p.m)}.${p.y}` : null;
};

export const formatRoDateTime = (v) => {
  const p = parseDateParts(v);
  if (!p) return null;
  const date = `${pad(p.d)}.${pad(p.m)}.${p.y}`;
  return p.dt ? `${date}, ${pad(p.dt.getHours())}:${pad(p.dt.getMinutes())}` : date;
};

export const formatRoMonthYear = (v) => {
  const p = parseDateParts(v);
  return p ? `${pad(p.m)}.${p.y}` : null;
};
